import React from 'react';
import ViewerStore from '../../stores/ViewerStore';
import * as Inovx from '@shared';
import ViewerActions from '../../actions/ViewerActions';
const { useState, useEffect, useRef } = React;

var InovxControls = Inovx.Shared.Controls;
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var SystemActions = Inovx.Shared.System.Actions;

interface AnnotationEditorProps {
    onClose?: () => void;
    left: number;
    top: number;
    target?: string;
}


const AnnotationEditor = React.forwardRef((props: AnnotationEditorProps, ref) => {
    const rteRef = useRef(null);
    const [selectedKVTag, setSelectedKVTag] = useState<IViewAnnotationTag>(null);
    const [textAnnotation, setTextAnnotation] = useState<string>(null);
    const [errors, setErrors] = useState({displayText:false,link:false});

    const [editorPosition, setEditorPosition] = useState({ x: 500, y: 200 });
    const [selectedAnnotation, setSelectedAnnotation] = useState<string>(ViewerStore.getSelectedAnnotation());
    const [annotationEditorMode, setAnnotationEditorMode] = useState(ViewerStore.getAnnotationEditorMode())
    const [annotationChange, setAnnotationChange] = useState(false);
    const updateViewerState = () => {
        if (ViewerStore.isPanoViewerVisible() || ViewerStore.is3DViewerVisible()) {
            setAnnotationEditorMode(ViewerStore.getAnnotationEditorMode())
            setSelectedAnnotation(ViewerStore.getSelectedAnnotation())
        }
    }
    useEffect(() => {
        const kvTagsInfo = ViewerStore.getSelectedKnowledgeView()?.Tags;
        const selectedAnnotation = ViewerStore.getSelectedAnnotation();
        const _selectedKVTag = kvTagsInfo?.find((tag) => tag.ID == selectedAnnotation);
        if (_selectedKVTag) {
            setTextAnnotation(_selectedKVTag.Text)
        }
        setSelectedKVTag(_selectedKVTag)
        
        const handleViewerStoreChange = () => {
            updateViewerState();
        };
        ViewerStore.addChangeListener(handleViewerStoreChange);
        return () => {
            ViewerStore.removeChangeListener(handleViewerStoreChange);
        }
    }, [selectedAnnotation]);

    const confirmSave = () => {
        _saveNote(true);
    }

    const discardChanges = () => {
        ViewerActions.setAnnotationEditorMode(false);
        ViewerActions.resetAnnotation();
        setAnnotationChange(false)
        props.onClose()
    }

    const _closeOpenNote = () => {
        if (annotationChange) {
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                confirmCallback: confirmSave,
                cancelCallback: discardChanges
            });
        } else {
            ViewerActions.setAnnotationEditorMode(false);
            ViewerActions.resetAnnotation();
            props.onClose()
        }
        
    }
    const isFormValid = () => {
        let isValid = true;
        let newErrors = { displayText: false, link: false }
        if (!textAnnotation) {
            isValid = false;
            newErrors.displayText = true;
        }
        setErrors(newErrors)
        return isValid;
    }
    const _saveNote = async (popupClose: boolean = false) => {
        if (!annotationChange) return;
        
        if (isFormValid()) {
            let annotation = selectedKVTag;
            // Only update the annotation if the text has actually changed
            annotation.Text = textAnnotation;
            await ViewerActions.editAnnotation(annotation);
            setAnnotationChange(false)
            if (popupClose) {
                ViewerActions.resetAnnotation();
                props.onClose()
            }
        } 
    }

    const _updateNotePosition = (e: Event, data: any) => {
        setEditorPosition({ x: data.deltaX, y: data.deltaY })
    }

    var cmdList = [
        <i title={InovxLoader.t("facility:action.saveAnnotation")} className={`fa fa-save ${!annotationChange ? 'disabled' : ''}`} onClick={() => _saveNote()} key="edit-note-save"></i>,
        <i title={InovxLoader.t("facility:action.close")} className='fa fa-times' onClick={_closeOpenNote} key="cancel-modal"></i>,
    ];
       
    var classes = ["edit-notes", "open-note"];
    var defaultWidth = 400;
    var defaultHeight = 70;

    const styleEditorPopup = () => {
        let panoViewerWidth = $(`${props.target ? props.target : "#pano-viewer"}`).width();
        let panoViewerHeight = $(`${props.target ? props.target : "#pano-viewer"}`).height();
        if (defaultWidth) {
            let left = props.left;
            let top = props.top;
            // Adjust left position based on icon position
            if (left + ((defaultWidth+15)/2) > panoViewerWidth) {
                left = panoViewerWidth - defaultWidth - 20;
            } else {
                left = (props.left) - (defaultWidth / 2);
            }

            // Adjust top position based on icon position
            if ((top + defaultHeight + 25) > panoViewerHeight) {
                let offset = (panoViewerHeight - top) + 10
                top = panoViewerHeight - defaultHeight - offset;
            } else {
                top = props.top + 55;
            }
            if (props.target) {
                left = left - 50;
                top = top - 80;
            }
            return { x: left, y: top }
        }
    }
    
    const _onChange = (event: any) => {
        if (event.target.value !== textAnnotation) {
            setAnnotationChange(true)
            setTextAnnotation(event.target.value);
        } else {
            setAnnotationChange(false)
            setTextAnnotation(event.target.value);
        }
        
    }

    return (
        <div className="opened-note-container" id="edit-annotation">
            <InovxControls.DraggablePanel containerClass={classes} minDimensions={{ x: 400, y: 384 }}
                commandList={cmdList}
                defaultSize={{ x: defaultWidth, y: defaultHeight }}
                //bounds={editorPosition}
                initialPosition={styleEditorPopup()}
                onDrag={_updateNotePosition}
            >
                <div className='edit-notes-container'>
                    <div className={`${errors.displayText ? 'has-error has-feedback' : ''}`}>
                        <input type="text" className="form-control" placeholder={InovxLoader.t("facility:form.displayText")} name="DisplayText" defaultValue={textAnnotation} onChange={_onChange} />
                    </div>
                </div>
            </InovxControls.DraggablePanel>
        </div>)
            
});

export default AnnotationEditor;